module.exports = new __parcel__URL__("rocket.cc345ebc.svg").toString();